import i18n from 'i18next';
import { initReactI18next, getI18n } from 'react-i18next';

import { initLanguage } from './initLanguage';
import Util from 'utils';

const resources = {
  en: {
    translation: `${CDN_BASE}language/EN/translate.json`
  },
  ms: {
    translation: `${CDN_BASE}language/MS/translate.json`
  },
  ko: {
    translation: `${CDN_BASE}language/KO/translate.json`
  },
  ja: {
    translation: `${CDN_BASE}language/JA/translate.json`
  },
  id: {
    translation: `${CDN_BASE}language/ID/translate.json`
  },
  cn: {
    translation: `${CDN_BASE}language/CN/translate.json`
  },
  th: {
    // 泰语
    translation: `${CDN_BASE}language/TH/translate.json`
  },
  'zh-tw': {
    // 繁体
    translation: `${CDN_BASE}language/TC/translate.json`
  },
  ru: {
    // 俄语
    translation: `${CDN_BASE}language/RU/translate.json`
  },
  km: {
    // 高棉语
    translation: `${CDN_BASE}language/KM/translate.json`
  },
  my: {
    // 缅甸语
    translation: `${CDN_BASE}language/MY/translate.json`
  },
  vi: {
    // 越南语
    translation: `${CDN_BASE}language/VI/translate.json`
  },
  lo: {
    // 老挝语
    translation: `${CDN_BASE}language/LO/translate.json`
  },
  de: {
    // 德语
    translation: `${CDN_BASE}language/DE/translate.json`
  }
};

// 使用我们的优化版本初始化语言
const lng = initLanguage();

i18n.use(initReactI18next).init({
  resources,
  // 默认语言  cn/en  中文/英文
  lng: resources[lng] ? lng : 'cn',
  interpolation: {
    escapeValue: false
  }
});
i18n.getI18n = getI18n;

export default i18n;



// WEBPACK FOOTER //
// ./src/config/language/config.js